import { render, staticRenderFns } from "./Vr.vue?vue&type=template&id=4fc15fcd&"
import script from "./Vr.vue?vue&type=script&lang=js&"
export * from "./Vr.vue?vue&type=script&lang=js&"
import style0 from "./Vr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports